import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { PAGES_ENDPOINTS } from '../../../constants/pages-endpoints';
function InternalLinkButton({
  caption,
  className,
  textColor,
  bgColor,
  fontSize,
  fontWeight,
  lineHeight,
  border,
  borderColor,
  padding,
  path,
  targetId,
  boxShadow,
  id
}) {
  return (
    <div className={className}>
      <Link
        id={id}
        to={path}
        href={`#${targetId}`}
        style={{ fontSize: fontSize, padding: padding, lineHeight: lineHeight, boxShadow: boxShadow }}
        className={`rounded cursor-pointer ${textColor} ${bgColor} ${fontWeight} ${border} ${borderColor} hover:bg-gray-700 hover:text-white`}
      >
        {caption}
      </Link>
    </div>
  );
}
export default InternalLinkButton;

InternalLinkButton.propTypes = {
  caption: PropTypes.string,
  className: PropTypes.string,
  textColor: PropTypes.string,
  bgColor: PropTypes.string,
  onClick: PropTypes.func,
  fontSize: PropTypes.string,
  bgColor: PropTypes.string,
  disabled: PropTypes.bool,
  fontWeight: PropTypes.string,
  border: PropTypes.string,
  fontWeight: PropTypes.string,
  borderColor: PropTypes.string,
  padding: PropTypes.string
};

InternalLinkButton.defaultProps = {
  padding: '11px 32px',
  textColor: 'text-white',
  fontSize: '12px',
  bgColor: 'bg-orange-500',
  lineHeight: '12px',
  fontWeight: 'text-medium',
  caption: 'Get Started',
  path: PAGES_ENDPOINTS?.GET_STARTED
};
